export default __webpack_public_path__ + "static/O0014-914a896e07b0610c641754795c83db2b.png";